export const local_storage_keys = {
  ACCESS_TOKEN: 'access-token',
  REFRESH_TOKEN: 'refresh-token',
  SHOP_ID: 'shop-id',
  STORE_NAME: 'store-name',
  APP_VERSION: 'app-version',
  GLOBAL_CONTEXT: 'global-context',
  VEHICLE_CONTEXT: 'vehicle-context',
  DEBT_CONTEXT: 'debt-context',
  ALERT_COUNTER: 'alert-counter',
  QR_CODE_CONTEXT: 'qr-code-context',
  EXPIRES_TOKEN_IN: 'expires-token-in',
  USER_LEVEL: 'user-level',
  OTP_CONTEXT: 'otp-context',
  RETURN_PATH: 'return-path', //path that need to save and return to it
  USER_INFO_CONTEXT: 'user-info-context',
  STATUS_TILE: 'status-tile',
  TILES: 'tiles',
  BANNERS: 'banners',
}

export const setAccessToken = (token: string) => {
  localStorage.setItem(local_storage_keys.ACCESS_TOKEN, token)
}

export const getAccessToken = () => {
  return localStorage.getItem(local_storage_keys.ACCESS_TOKEN)
}

export const deleteAccessToken = () => {
  return localStorage.removeItem(local_storage_keys.ACCESS_TOKEN)
}

export const setRefreshToken = (token: string) => {
  localStorage.setItem(local_storage_keys.REFRESH_TOKEN, token)
}

export const getRefreshToken = () => {
  return localStorage.getItem(local_storage_keys.REFRESH_TOKEN)
}

export const deleteRefreshToken = () => {
  return localStorage.removeItem(local_storage_keys.REFRESH_TOKEN)
}

export const setShopIdOnLocal = async (shopId) => {
  await localStorage.setItem(local_storage_keys.SHOP_ID, shopId)
}

export const getShopId = () => {
  return localStorage.getItem(local_storage_keys.SHOP_ID)
}

export const deleteShopId = () => {
  return localStorage.clear(local_storage_keys.SHOP_ID)
}

export const setStoreName = (storeName) => {
  localStorage.setItem(local_storage_keys.STORE_NAME, storeName)
}

export const getStoreName = () => {
  return localStorage.getItem(local_storage_keys.STORE_NAME)
}

export const deleteStoreName = () => {
  return localStorage.clear(local_storage_keys.STORE_NAME)
}
export const setAppVersion = (appVersion) => {
  return localStorage.setItem(local_storage_keys.APP_VERSION, appVersion)
}

export const getAppVersion = () => {
  return localStorage.getItem(local_storage_keys.APP_VERSION)
}

export const getExprireTokenIn = () => {
  return localStorage.getItem(local_storage_keys.EXPIRES_TOKEN_IN)
}
9
export const setExprireTokenIn = (expireTokenIn: string) => {
  return localStorage.setItem(
    local_storage_keys.EXPIRES_TOKEN_IN,
    expireTokenIn,
  )
}

export const getUserLevel = () => {
  return localStorage.getItem(local_storage_keys.USER_LEVEL)
}

export const setUserLevel = (userLevel: string) => {
  return localStorage.setItem(local_storage_keys.USER_LEVEL, userLevel)
}

export const getReturnPath = () => {
  return localStorage.getItem(local_storage_keys.RETURN_PATH)
}

export const setReturnPath = (returnPath: string) => {
  return localStorage.setItem(local_storage_keys.RETURN_PATH, returnPath)
}

export const setStatusTile = (statusTile: []) => {
  return localStorage.setItem(
    local_storage_keys.STATUS_TILE,
    JSON.stringify(statusTile),
  )
}

export const getStatusTile = () => {
  return localStorage.getItem(local_storage_keys.STATUS_TILE)
}

export const clearStatusTile = () => {
  return localStorage.removeItem(local_storage_keys.STATUS_TILE)
}

export const getTiles = () => {
  return localStorage.getItem(local_storage_keys.TILES)
}

export const setTilesOnLocal = (tiles: []) => {
  return localStorage.setItem(local_storage_keys.TILES, JSON.stringify(tiles))
}

export const clearTiles = () => {
  return localStorage.removeItem(local_storage_keys.TILES)
}

export const getBannersOnLocal = ({ bannersType }: { bannersType: string }) => {
  return localStorage.getItem(local_storage_keys.BANNERS + bannersType)
}

export const setBannersOnLocal = ({
  bannersType,
  banners,
}: {
  bannersType: string
  banners: any[]
}) => {
  return localStorage.setItem(
    local_storage_keys.BANNERS + bannersType,
    JSON.stringify(banners),
  )
}

export const clearBanners = ({ bannersType }: { bannersType: string }) => {
  return localStorage.removeItem(local_storage_keys.BANNERS + bannersType)
}
